import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import { baseApiSlice } from "@src/services/slices/baseApiSlice";
import { message } from "antd";
import { HTTP_METHODS } from "@src/constants";
import { NotificationOverview } from "@src/types/notification_types";

export const NotificationsApi = baseApiSlice.injectEndpoints({
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    /* GET endpoints */
    ...getEndpoints(builder),
  }),
});

function getEndpoints(builder: EndpointBuilder<any, any, any>) {
  return {
    /**
     * Get all notifications
     */
    getNotifications: builder.query<
      NotificationOverview,
      { startDate: string; endDate: string }
    >({
      query: (queryParameter) => ({
        url: "/notifications",
        method: HTTP_METHODS.GET,
        params: {
          startDate: queryParameter.startDate,
          endDate: queryParameter.endDate,
        },
      }),
      transformErrorResponse: async () => {
        message.error("Unable to load notifications", 5);
      },
      providesTags: ["Notifications"],
    }),
  };
}

export const {
  // GET
  useGetNotificationsQuery,
} = NotificationsApi;
